var Curriculog = Curriculog || {};

Curriculog.User = (function ($, _, Backbone, User) {

	User = Curriculog.CurriculogModel.extend({
		name: function () {
			var name = this.get('first_name') + ' ' + this.get('last_name');
			return name;
		},

	});
	return User;

})($, _, Backbone, Curriculog.User || {});
